import React, { Fragment } from 'react'
//import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import 'bootstrap/dist/css/bootstrap.min.css'
import { Calendar, momentLocalizer } from 'react-big-calendar'
import moment from 'moment'
import 'react-big-calendar/lib/css/react-big-calendar.css'

const spanStyle = {
  color: '#F08922',
  fontWeight: 'bold',
}

const localizer = momentLocalizer(moment)

const customDayPropGetter = (date, publicHolidays) => {
  const formattedDate = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
  if (publicHolidays.includes(formattedDate)) {
    return {
      className: 'special-day',
      style: {
        backgroundColor: '#99FF99',
      },
    }
  } else if (date.getDay() === 0 || date.getDay() === 6) {
    return {
      className: 'special-day',
      style: {
        backgroundColor: '#f2f2f2',
      },
    }
  } else {
    return {}
  }
}

class CalendarAccounting extends React.Component {
  constructor(props) {
    super(props)
    if (this.props.accounting.colors) {
      this.state = {
        evs: props.accounting.events,
      }
    }
  }

  render() {
    if (this.props.accounting.colors) {
      return <Fragment><div className="row"><div className="col-sm-6" style={{ paddingLeft: '0px', display: this.props.accounting.next_vacation !== '' ? 'block' : 'none'}}>Your next vacation<span style={spanStyle}> {this.props.accounting.next_vacation}</span></div></div><div className="row"><Calendar localizer={localizer} events={this.state.evs} views={[ 'month' ]} culture={'en-GB'} selectable={false} onShowMore={(events, date) => console.error(events + ';' + date)} popup={true} startAccessor="start" endAccessor="end" defaultDate={moment().toDate()} style={{ height: 580, width: '100%' }} dayPropGetter={(date) => customDayPropGetter(date, this.props.accounting.public_holidays)} onNavigate={date => { this.fetchData(this.props.accounting.user.id, date) } } eventPropGetter={
              (event) => {
                const newStyle = {
                  backgroundColor: 'lightgrey',
                  color: 'black',
                  borderRadius: '0px',
                  border: 'none',
                  height: '30px',
                }

                newStyle.backgroundColor = event.color

                return {
                  className: '',
                  style: newStyle,
                }
              }
            }></Calendar></div></Fragment>
    }
    return <div>Waiting</div>
  }

  fetchData(uid, date) {
    const vrs = String(date).split(' ')
    const mth = date.getMonth() + 1
    fetch('/api/v1/show_month_year/' + uid + '/' + mth + '/' + vrs[3], {
      method: 'GET',
      dataType: 'JSON',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
      },
    })
    .then((resp) => {
      return resp.json()
    })
    .then((data) => {
      this.setState({ evs: data.events })
      this.props.setMonth(data.month)
      this.props.setStatistics(data.statistics)
      this.props.setPublicHolidays(data.public_holidays)
    })
    .catch((error) => {
      console.error(error, 'catch the hoop')
    })
  }
}

CalendarAccounting.propTypes = {
  accounting: PropTypes.object,
  setMonth: PropTypes.func,
  setStatistics: PropTypes.func,
  setPublicHolidays: PropTypes.func,
}

export default CalendarAccounting
